
import React from "react";

const ParallexSpinner = ({
  label = "Loading...",
  size = "md",
  fullPage = false,
}) => {
  const sizes = {
    sm: "h-6 w-6 border-[3px]",
    md: "h-10 w-10 border-4",
    lg: "h-14 w-14 border-4",
  };

  return (
    <div
      className={`flex flex-col items-center justify-center ${
        fullPage ? "min-h-screen" : ""
      }`}
      role="status"
      aria-live="polite"
    >
      <div
        className={`relative ${sizes[size] || sizes.md} rounded-full border-[#271B91]/20 border-t-[#DB9E27] animate-spin`}
        aria-hidden="true"
      >
        <span className="absolute inset-1 rounded-full border-2 border-transparent border-b-[#271B91]/70" />
      </div>

      {label && (
        <p className="mt-3 text-sm font-medium text-[#271B91]">
          {label}
        </p>
      )}

      <span className="sr-only">{label || "Loading"}</span>
    </div>
  );
};

export default ParallexSpinner;
